export default "__VITE_ASSET__CcCIhI9m__"